export default __webpack_public_path__ + "static/media/logo-white.5ba55bf5.png";